import {Component, OnInit} from '@angular/core';
import {process, SortDescriptor} from '@progress/kendo-data-query';
import {ExcelExportEvent, GridComponent, PageChangeEvent} from '@progress/kendo-angular-grid';
import {GLAudit} from '../../../core/shared/model/GLAudit';
import {GlguideService} from '../../../core/services/glguide.service';
import {Observable} from 'rxjs';
import {ExcelExportData} from '@progress/kendo-angular-excel-export';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-glguideaudit',
  templateUrl: './glguideaudit.component.html',
  styleUrls: ['./glguideaudit.component.scss']
})

export class GLGuideAuditComponent implements OnInit {
  public glAuditReview: Array<GLAudit> = this.glGuideService.glAuditList;
  skip = 0;
  pageSize: number = 60;
  selectedKeys: string[];
  public range = {start: null, end: null};

  sort: SortDescriptor[] = [{
    field: 'siteName',
    dir: 'asc'
  }];
  format = 'yyyy-MM-dd';
  scale = 0.7;

  constructor(public glGuideService: GlguideService,
              public loadingIndicator: LoadingIndicatorHelper,
              public dialogService: FSInvoiceDialogService) {
    this.exportAllData = this.exportAllData.bind(this);

  }

  pageChange({skip, take}: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  async filterDates() {

    if (!this.range.start || !this.range.end) {
      await this.dialogService.openDialog({
        type: DialogType.ERROR,
        title: 'GL Audit',
        content: 'Please enter dates for filter',
        actions: [
          {text: 'Ok', primary: true},
        ],
        width: 400
      });
    } else {
      await this.glGuideService.getGLAuditItems(this.range.start, this.range.end).then(r => r);
      this.glAuditReview = this.glGuideService.glAuditList;
    }
  }

  ngOnInit(): void {
    this.loadingIndicator.hide();
  }

//Excel export
  public exportAllData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.glAuditReview, {}).data,
    };
    return result;
  }

  excelExported($event: ExcelExportEvent) {
    const sheet = $event.workbook.sheets[0];
    sheet.freezePane.rowSplit = 0;
    sheet.name = 'Gl-reviewAuditGuide';
  }

  exportToExcel(glAuditReview: GridComponent) {
    try {
      this.loadingIndicator.show();
      setTimeout(() => {
        glAuditReview.saveAsExcel();
        this.loadingIndicator.hide();
      }, 100);
    } catch (ex) {
      this.dialogService.showErrorNotification('There was a problem exporting this worksheet, please try again later');
      this.loadingIndicator.hide();
    }
  }

  //PDF export
  exportToPDF(glAuditReview: GridComponent) {
    try {
      this.loadingIndicator.show();
      setTimeout(() => {
        glAuditReview.saveAsPDF();
        this.loadingIndicator.hide();
      }, 100);
    } catch (ex) {
      this.dialogService.showErrorNotification('There was a problem exporting this worksheet, please try again later');
      this.loadingIndicator.hide();
    }
  }
}
